var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTyperightUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.334 5.551A.5.5 0 0 0 7.831 6h9.543L5.146 18.228a.5.5 0 1 0 .708.707L18.08 6.707v9.543a.5.5 0 1 0 1 0V5.494a.497.497 0 0 0-.5-.494H7.831a.5.5 0 0 0-.497.551Z",
  fill: "currentColor"
})));
export { SvgTyperightUp as ReactComponent };
export default __webpack_public_path__ + "0712d1ee51a6ff06bad898abee08eda8.svg";